import { createContext, useContext } from "react";

export const DriscollHomeContext = createContext(false);
export const useDriscollHome = () => useContext(DriscollHomeContext);

// The public API omits the domain for local accounts; presentation does not.
export function accountHandle(account) {
  const acct = (account?.acct ?? "").replace(/^@/, "");
  if (!acct || acct.includes("@")) return acct;
  try {
    return `${acct}@${new URL(account.url).hostname}`;
  } catch {
    return acct;
  }
}
